module.exports = __webpack_public_path__ + "static/media/60.1890c501.jpg";